import { Component, OnInit, AfterViewInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { trigger, style, state, transition, animate, useAnimation } from '@angular/animations';
import { ConnectionService } from 'ng-connection-service';
import { WINDOW } from '@ng-toolkit/universal';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('rightSideMenu', [
      state('show', style({
        display: 'block',
      })),
      state('hide', style({
        display: 'none',
        position: 'fixed',
        right: '-232px',
      })),
      transition('show => hide', animate('600ms ease-out')),
      transition('hide => show', animate('600ms ease-in'))
    ]),

    trigger('header-thumb', [
      state('show', style({
        opacity: 1,
      })),
      state('hide', style({
        opacity: 0,
        display: 'none'
      })),
      transition('show => hide', animate('500ms ease-out')),
      transition('hide => show', animate('400ms ease-in'))
    ])

  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public avatar: any;
  public role: any;
  show = false;
  panelOpenState = false;

  profilePanel: boolean = false;
  constructor(@Inject(WINDOW) private window: Window, private changedetection: ChangeDetectorRef) { }
  get SideMenu() {
    return this.show ? 'show' : 'hide'
  }
  toggleMenu() {
    this.show = !this.show
  }

  get thumb() {
    return this.profilePanel ? 'show' : 'hide'
  }
  toggleThumbline() {
    this.profilePanel = !this.profilePanel
  }

  ngOnInit() {

    // variable delaration
    let toggleButton = document.getElementById('toggleButton');//menu button
    let closeSlidebar = document.getElementById('menuClose');//menu close button
    let slideBar = document.getElementsByClassName('sidebar')[0];//menu left sidebar

    this.changedetection.markForCheck();
    this.avatar = sessionStorage.getItem('UserName');
    this.role = sessionStorage.getItem('Role');

    console.log(this.avatar);
    console.log(this.role);

    if (this.window.screen.width < 768) {
      slideBar.classList.add('animated', 'fadeOutLeft');
    }

    // screen size lessthen 768 
    const onResize = function (e) {
      const Width = e.target.outerWidth;

      if (Width < 768) {
        slideBar.classList.add('animated', 'fadeOutLeft');
      }
      if (Width > 768) {
        slideBar.classList.add('animated', 'fadeIntLeft');
        slideBar.classList.remove('fadeOutLeft');
      }

    }
    this.window.addEventListener("resize", onResize);

    // open button click
    toggleButton.onclick = function (event) {
      slideBar.classList.toggle('fadeInLeft');
      slideBar.classList.remove('fadeOutLeft');
    }



    //  close button click
    // closeSlidebar.onclick = function(){
    //   slideBar.classList.add('fadeOutLeft');
    //   slideBar.classList.remove('fadeInLeft');
    // }
    // swipe right
    // var canvas = document.getElementById('canvas');
    // var swipeRight = new Hammer(canvas);

    // swipe
    // swipeRight.on("swiperight", function(ev) {
    //   slideBar.classList.toggle('fadeInLeft');
    //   slideBar.classList.remove('fadeOutLeft');
    // });

  }

  logOut() {
    sessionStorage.removeItem('UserName');
    sessionStorage.removeItem('Role');


  }

  ngAfterViewInit() {
  }

}
